class LinkedInTracker {
    constructor(config) {
        this.name = 'linkedin';
        this.trackActivity = ({ type, conversionId }) => {
            if (type === 'click' && conversionId) {
                window.lintrk('track', { conversion_id: conversionId });
            }
        };
        const { partnerId } = config;
        this.name = 'linkedin';
        window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
        window._linkedin_data_partner_ids.push(partnerId);
        const firstScript = document.head.getElementsByTagName('script')[0];
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.src = 'https://snap.licdn.com/li.lms-analytics/insight.min.js';
        if (firstScript?.parentNode) {
            firstScript.parentNode.insertBefore(script, firstScript);
        }
        const url = `https://px.ads.linkedin.com/collect/?pid=${partnerId}&fmt=gif`;
        const element = document.createElement('img');
        element.alt = '';
        element.height = 1;
        element.width = 1;
        element.src = url;
        document.body.insertAdjacentElement('beforeend', element);
    }
}
export default LinkedInTracker;
//# sourceMappingURL=linkedIn.js.map